export default class AuthorizationError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'AuthorizationError';

        Object.setPrototypeOf(this, AuthorizationError.prototype);
    }
}
